import React from 'react';
import PropTypes from 'prop-types';

import Toast from "components/WMS/Toast";

import DeleteIcon from 'assets/img/error.svg'

PickingErrorToast.propTypes = {
    message: PropTypes.element,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func
};

function PickingErrorToast({message = null, open = false, handleClose = () => {}}) {
    if (message === null) {
        return null;
    }

    return (
        <Toast
            open={open}
            handleClose={handleClose}
            isDesktop={false}
            isTop={false}
            customTimeout={2000}
            icon={<img style={{height: '20px', width: '20px'}} src={DeleteIcon} alt={"delete-icon"}/>}
            title={message}
        />
    );
}

export default PickingErrorToast;
